// In Next.js, this file would be called: app/providers.tsx
'use client';

// Since QueryClientProvider relies on useContext under the hood, we have to put 'use client' on top
import { useMemo } from 'react';

import {
    QueryClient,
    QueryClientProvider,
    isServer,
} from '@tanstack/react-query';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Provider, createStore } from 'jotai';
import { Session } from 'next-auth';
import { SessionProvider } from 'next-auth/react';

// In Next.js, this file would be called: app/providers.tsx

// In Next.js, this file would be called: app/providers.tsx

// Create a single Jotai store that persists across renders
const jotaiStore = createStore();

// In Next.js, this file would be called: app/providers.tsx

function makeQueryClient() {
    return new QueryClient({
        defaultOptions: {
            queries: {
                // With SSR, we usually want to set some default staleTime
                // above 0 to avoid refetching immediately on the client
                staleTime: 60 * 1000,
            },
        },
    });
}

let browserQueryClient: QueryClient | undefined = undefined;

export function getQueryClient() {
    if (isServer) {
        // Server: always make a new query client
        return makeQueryClient();
    } else {
        // Browser: make a new query client if we don't already have one
        // This is very important, so we don't re-make a new client if React
        // suspends during the initial render. This may not be needed if we
        // have a suspense boundary BELOW the creation of the query client
        if (!browserQueryClient) browserQueryClient = makeQueryClient();
        return browserQueryClient;
    }
}

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 300 * 1000, // 5 minutes
            refetchOnMount: false,
            refetchOnWindowFocus: false,
        },
    },
});

export default function Providers({
    session,
    children,
}: {
    session: Session | null;
    children: React.ReactNode;
}) {
    // Stabilize the session key to prevent unnecessary SessionProvider remounts
    const memoizedSessionKey = useMemo(() => {
        return session?.user?.id || 'no-session';
    }, [session?.user?.id]);

    // console.log('Providers: rendering with session', {
    //     userId: session?.user?.id,
    //     sessionKey: memoizedSessionKey,
    // });

    return (
        <SessionProvider session={session} key={memoizedSessionKey}>
            <Provider store={jotaiStore}>
                <QueryClientProvider client={queryClient}>
                    {children}
                    {/* <ReactQueryDevtools /> */}
                </QueryClientProvider>
            </Provider>
        </SessionProvider>
    );
}
